import styled from '@emotion/styled';
import Button from '~/components/Button';
import Gap from '~/components/Gap';
import ModalWrapper from '~/components/ModalWrapper';
import ModalHeader from '~/components/ModalWrapper/ModalHeader';
import Text from '~/components/Text';

interface IWarningModalProps {
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

const ModalContent = styled.div`
  background: var(--white);
  border-radius: 12px;
  padding: 16px;
  margin: 0 16px;
`;

const WarningModal = ({
  isVisible,
  onConfirm,
  onCancel,
  title = 'Discard changes?',
  message = 'Are you sure you want to leave? Your unsaved changes will be lost and cannot be recovered.',
  confirmText = 'Discard',
  cancelText = 'Cancel',
}: IWarningModalProps) => {
  return (
    <ModalWrapper isVisible={isVisible} modalWidth="400px" handleClose={onCancel}>
      <ModalContent className="full-width">
        <ModalHeader handleClose={onCancel} headerJsx="" />

        <Text size="sm" className="bold">
          {title}
        </Text>
        <Gap t={12} />

        <Text size="xs">
          {message}
        </Text>

        <Gap t={24} />

        <div className="align-center">
          <Button className="full-width" variant="secondary" size="md" onClick={onCancel}>
            {cancelText}
          </Button>

          <Gap l={12} />

          <Button variant="danger" className="full-width" size="md" onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
      </ModalContent>
    </ModalWrapper>
  );
};

export default WarningModal;
